import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../config/apiConfig.js';
import { getRequest } from '../util/httpRequest.js';

import { getAppConfigData } from '../reducers/appConfigReducer.js';
import { put, takeEvery, call, select } from 'redux-saga/effects';

export function* listener(serviceType, action) {
  try {
    // Dispatch growthDimensionGridColumns_LOADING action
    yield put(createServiceAction(serviceType, 'loading')(true));
    yield put(createServiceAction(serviceType, 'error')(''));
    yield put(
      createServiceAction(serviceType, 'growthDimensionGridColumns')({})
    );

    let options = {};
    let getDashDataUrl = `${apiConfig.growthDimensionGridColumns.endPointUrl}dashboard/${action.data.dashboard}`;

    if (action.data.type === 'static') {
      getDashDataUrl = apiConfig.growthDimensionGridColumns.endPointUrl;
      options = { growthDimensionType: action.data.growthDimension };
    }
    // Trigger Call to API endpoint
    const res = yield call(getRequest, getDashDataUrl, options, true);
    // Parse response object
    const response = yield res.json();
    const appConfig = yield select(getAppConfigData);
    if (response && appConfig) {
      // appConfig.revisedViewConfig = { maxCapacityEditable: true }; //making testing
      response.appConfig = appConfig;
    }
    // Dispatch growthDimensionGridColumns_LOADING action with response object
    yield put(createServiceAction(serviceType, 'loading')(false));
    yield put(createServiceAction(serviceType, 'success')(response));
  } catch (e) {
    // Dispatch growthDimensionGridColumns_ERROR action with captured error data
    yield put(createServiceAction(serviceType, 'loading')(false));
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* growthDimensionGridColumnsSagas() {
  const serviceType = 'growthDimensionGridColumns';
  // Listen to growthDimensionGridColumns_REQUESTED actions
  yield takeEvery(
    createServiceAction(serviceType, 'requested').type,
    listener,
    serviceType
  );
}

export default growthDimensionGridColumnsSagas;
